module.exports = __webpack_public_path__ + "img/ic_daily_checkins.a592d383.png";